(() => {
  const SECTION_ID = "api-product-soldout-notification";

  const interactionEvents = ["pointerdown", "keydown", "change"];

  if (customElements.get("soldout-notification")) return;

  class SoldoutNotification extends HTMLElement {
    constructor() {
      super();

      this.selectors = {
        section: "[data-section-type]",
        popup: "popup-component",
        popupOpen: "[data-popup-open]",
        variantId: 'input[name="id"]',
        variantTitle: "[data-variant-title]",
        notificationProduct: "[data-notification-product]",
        buttonText: ".btn__text",
        cartBarButton: "[data-cart-bar-product-notification]",
        cartBarButtonText: "[data-cart-bar-notification-text]",
      };

      this.request = null;
      this.inserted = false;
      this.userInteracted = false;
      this.onInteraction = this.onInteraction.bind(this);
      this.onVariantChange = this.onVariantChange.bind(this);
    }

    connectedCallback() {
      this.container = this.closest(this.selectors.section);
      if (!this.container || !this.dataset.url) return;

      if (this.isReturningFromSubmit()) {
        const variantId = this.container.querySelector(
          this.selectors.variantId,
        )?.value;
        if (variantId) this.load(variantId);
        return;
      }

      interactionEvents.forEach((type) =>
        this.container.addEventListener(type, this.onInteraction, true),
      );
      this.container.addEventListener(
        "theme:variant:change",
        this.onVariantChange,
      );
    }

    disconnectedCallback() {
      if (!this.container) return;
      interactionEvents.forEach((type) =>
        this.container.removeEventListener(type, this.onInteraction, true),
      );
      this.container.removeEventListener(
        "theme:variant:change",
        this.onVariantChange,
      );
    }

    onInteraction(event) {
      if (!event.isTrusted) return;
      this.userInteracted = true;
      interactionEvents.forEach((type) =>
        this.container.removeEventListener(type, this.onInteraction, true),
      );
    }

    onVariantChange(event) {
      const variant = event.detail?.variant;
      if (!this.userInteracted || !variant) return;

      this.variant = variant;

      if (this.inserted) {
        this.updateVariant(variant);
        return;
      }

      if (variant.available === false) {
        // Sync to the latest selection
        this.load(variant.id).then(() => this.updateVariant(this.variant));
      }
    }

    load(variantId) {
      if (this.request) return this.request;

      const url = new URL(this.dataset.url, window.location.origin);

      new URLSearchParams(window.location.search).forEach((value, key) =>
        url.searchParams.set(key, value),
      );
      url.searchParams.set("variant", variantId);
      url.searchParams.set("section_id", SECTION_ID);

      this.request = fetch(url.toString())
        .then((response) => {
          if (!response.ok)
            throw new Error(`${response.status} ${response.statusText}`);
          return response.text();
        })
        .then((html) => {
          const popup = new DOMParser()
            .parseFromString(html, "text/html")
            .querySelector(this.selectors.popup);
          if (!popup)
            throw new Error(
              "Sold out notification markup missing from response",
            );

          const buttonClass = this.dataset.buttonClass;
          const button = popup.querySelector(this.selectors.popupOpen);
          if (button && buttonClass) button.className = `btn ${buttonClass}`;

          this.appendChild(popup);
          this.inserted = true;

          this.revealCartBarButton(
            button
              ?.querySelector(this.selectors.buttonText)
              ?.textContent.trim(),
          );
        })
        .catch((error) => {
          this.request = null;
          console.error("[soldout-notification]", error);
        });

      return this.request;
    }

    revealCartBarButton(text) {
      if (!text) return;

      this.container
        .querySelectorAll(this.selectors.cartBarButton)
        .forEach((cartBarButton) => {
          const cartBarButtonText = cartBarButton.querySelector(
            this.selectors.cartBarButtonText,
          );
          if (cartBarButtonText) cartBarButtonText.textContent = text;
          cartBarButton.hidden = false;
        });
    }

    updateVariant(variant) {
      if (!this.inserted) return;

      const variantTitle = this.querySelector(this.selectors.variantTitle);
      const notificationProduct = this.querySelector(
        this.selectors.notificationProduct,
      );

      if (variantTitle) variantTitle.textContent = variant.title;
      if (notificationProduct) notificationProduct.value = variant.name;
    }

    isReturningFromSubmit() {
      if (window.location.search.indexOf("contact_posted=true") === -1)
        return false;

      try {
        const formId = window.sessionStorage.getItem("notification_form_id");
        return Boolean(formId && formId.startsWith("NotificationForm--"));
      } catch (e) {
        return false;
      }
    }
  }

  customElements.define("soldout-notification", SoldoutNotification);
})();
